






















































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import i18nService from '@/services/i18n';
import { Ax } from '@/utils';
import {staffTabAccess, store} from '../common';
import { ListItem, ListItemPart, Overlay, svgIcons } from '../components';
import I18n from '../I18n';
import { SingleOrgField } from '../organizations';
import { Dict, Org } from '../types';
import ConfirmModal from "@/modules/budget/staffing-table/components/ConfirmModal.vue";
import FavoriteImportModal from './FavoriteImportModal.vue';
import {BIcon, BIconArrowClockwise, BIconFileEarmarkExcel} from "bootstrap-vue";
import {SvgIcon} from "@/components/custom";


const i18n = new I18n('modules.budget.staffing_table.versions');

const translates = {
    get cancel(): string {
        return i18nService.choose(
            'Отмена',
            'Бас тарту',
            'Cancel',
        );
    },
    get copyData(): string {
        return i18nService.choose(
            'Копировать данные',
            'Деректерді көшіру',
            'Copy data',
        );
    },
    get create(): string {
        return i18nService.choose(
            'Создать',
            'Жасау',
            'Create',
        );
    },
    favoriteImport: {
        get actionTitle(): string {
            return i18nService.choose(
                'Импорт из Favorit',
                'Favorit жүйесінен импорттау',
                'Import from Favorit',
            );
        },
    },
    dataTransfer: {
        get actionTitle(): string {
            return i18nService.choose(
                'Перенос данных',
                'Деректерді тасымалдау',
                'Data transfer',
            );
        },
        fields: {
            org: {
                get title(): string {
                    return i18nService.choose(
                        'Гос.учреждение/ГККП',
                        'Мемлекеттік мекеме/МКҚК',
                        'State institution/SCSE',
                    );
                },
            },
        },
        get modalTitle(): string {
            return i18nService.choose(
                'Выберите ГУ/ГККП, куда перенести данные Версии ШР',
                'ҚК нұсқасы деректерін тасымалдағыңыз келетін мемлекеттік кәсіпорынды/мемлекеттік кәсіпорынды таңдаңыз',
                'Select the ГУ/ГККП where you want to transfer the ST Version data',
            );
        },
    },
    fields: {
        title: {
            get title(): string {
                return i18nService.choose(
                    'Наименование ШР',
                    'ҚК атауы',
                    'ST title',
                );
            },
        },
        year: {
            get title(): string {
                return i18nService.choose(
                    'Год версии ШР',
                    'ҚК жылының нұсқасы',
                    'ST version year',
                );
            },
        },
    },
    favoriteImportStatus: {
        dataSource: {
            get title(): string {
                return i18nService.choose(
                    'Источник данных',
                    'Деректер көзі',
                    'Data source',
                );
            },
            get favorit(): string {
                return i18nService.choose(
                    'Favorit',
                    'Favorit',
                    'Favorit',
                );
            },
            get eAkimat(): string {
                return i18nService.choose(
                    'eAkimat365',
                    'eAkimat365',
                    'eAkimat365',
                );
            },
        },
        status: {
            get title(): string {
                return i18nService.choose(
                    'Статус',
                    'Мәртебесі',
                    'Status',
                );
            },
            get created(): string {
                return i18nService.choose(
                    'В очереди',
                    'Кезекте',
                    'Queued',
                );
            },
            get importing(): string {
                return i18nService.choose(
                    'Идёт обработка',
                    'Өңделуде',
                    'Processing',
                );
            },
            get success(): string {
                return i18nService.choose(
                    'Обработано',
                    'Өңделді',
                    'Processed',
                );
            },
            get partialSuccess(): string {
                return i18nService.choose(
                    'Частично обработано',
                    'Ішінара өңделді',
                    'Partially processed',
                );
            },
            get failed(): string {
                return i18nService.choose(
                    'Ошибка',
                    'Қате',
                    'Error',
                );
            },
            refresh: {
                get title(): string {
                    return i18nService.choose(
                        'Обновить статус',
                        'Мәртебені жаңарту',
                        'Refresh status',
                    );
                },
            },
            downloadErrors: {
                get title(): string {
                    return i18nService.choose(
                        'Скачать отчёт об ошибках',
                        'Қателер туралы есепті жүктеп алу',
                        'Download error report',
                    );
                },
            },
            errors: {
                get refresh(): string {
                    return i18nService.choose(
                        'Не удалось обновить статус импорта',
                        'Импорт мәртебесін жаңарту мүмкін болмады',
                        'Failed to refresh import status',
                    );
                },
                get errorsImportLoadingError(): string {
                    return i18nService.choose(
                        'Не удалось загрузить отчет об ошибках',
                        'Импорт қателері туралы есепті жүктеу мүмкін болмады',
                        'Failed to download the import error report',
                    );
                }
            },
        },
    },
};
// Цвета бейджей "Источник данных" / "Статус" (см. дизайн-мокап версий ШР)
const dataSourceColors = {
    favorit: '#A0522D',
    eAkimat: '#28a745',
};

const statusColors = {
    created: '#6c757d',
    importing: '#fd7e14',
    success: '#28a745',
    partialSuccess: '#d4ac0d',
    failed: '#dc3545',
};

interface FavoriteImportStatus {
    status: FavoriteImportStatusEnum;
    progress: number;
    savedEmpCount: number | null;
    importedAt: string | null;
    /** Есть ошибки импорта с кодом EMPLOYEE_NOT_LOADED или DISPLAYABLE_ERROR_TO_USER (видны обычному пользователю) */
    userErrors: boolean;
}

interface Version {
    id: number;
    year: number;
    title: string;
    newTitle?: string;  // Присваиваем новое имя заголовка
    favoriteImport?: FavoriteImportStatus | null;
}

enum FavoriteImportStatusEnum {
    CREATED = 'CREATED',
    IMPORTING_EMPLOYEES = 'IMPORTING_EMPLOYEES',
    SUCCESS = 'SUCCESS',
    PARTIAL_SUCCESS = 'PARTIAL_SUCCESS',
    FAILED = 'FAILED',
}


@Component({
    components: {
        SvgIcon,
        ConfirmModal,
        ListItem,
        ListItemPart,
        Overlay,
        SingleOrgField,
        FavoriteImportModal,
        'b-icon': BIcon,
        'b-icon-arrow-clockwise': BIconArrowClockwise,
        'b-icon-file-earmark-excel': BIconFileEarmarkExcel,
    },
})
export default class Page extends Vue {

  get variantState(): boolean {
    return true;
  }
    private svgIcons = svgIcons;
    private FavoriteImportStatusEnum = FavoriteImportStatusEnum;

    // region Lifecycle
    private created() {
        // region Org
        this.$watch('org', (org: Org | null) => {
            store.org = org;
            store.version = null
            store.subDepartments = []
            store.gaDepartmentList = [];
            store.conditionExp = null
            this.selectedVersion = null;
            this.refreshingVersionIds = [];
            this.resetVersions();
        });
        // endregion
    }

    private mounted() {
        this.resetVersions();
    }
    // endregion

    // Доступ к редактированию данных
    get isEditable(): boolean {
        return staffTabAccess.isEditable;
    }

    // region Utils
    private i18n = i18n;

    private get loading(): boolean {
        return this.versionsLoading;
    }

    private toast(type: 'danger' | 'warning' | 'success', title: string, message: string) {
        this.$bvToast.toast(message, {
            title: title,
            variant: type,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        });
    }

    private translates = translates;
    // endregion


    // region Org
    private org: Org | null = store.org;
    // endregion

    // confirmModal
    private showConfirmModal: boolean = false
    private closeConfirmModal() {
        this.showConfirmModal = false
    }
     deleteVersion() {
        this.showConfirmModal = true
    }


    // region Modal window "new version" - year, title, org
    private paramsModalYear: number = 0;
    private paramsModalTitle: string = '';
    private paramsModalVisible = false;
    private paramsModalOrg: Org | null = null;
    private paramsModalOrgVisible: boolean = false;

    private paramsModalTextTitle: string = '';
    private paramsModalOkTitle: string = '';

    private get paramsModalOkDisabled(): boolean {
        if (this.paramsModalOrgVisible) {
            const paramsModalOrg = this.paramsModalOrg;
            if (paramsModalOrg === null) {
                return true;
            }

            const org = this.org;
            if (org === null) {
                return true;
            }

            return (paramsModalOrg.org.code === org.org.code);
        } else {
            return false;
        }
    }

    private onParamsModalOk() {
        this.continueVersionCreation();
    }

    private onParamsModalCancel() {
        this.paramsModalVisible = false;
    }

    // region Modal window "Favorit import"
    private favoriteImportModalVisible = false;

    private onFavoriteImportClick() {
        this.favoriteImportModalVisible = true;
    }
    // endregion


    // region Versions
    // noinspection JSMismatchedCollectionQueryUpdate
    private versions: Array<Version> = [];
    private versionsLoading = false;
    private selectedVersion: Version | null = null;
    private oldVersion: Version | null = null;

    private resetVersions() {
        if (this.org === null) {
            this.versions = [];
        } else {
            this.reloadVersions();
        }
    }

    private reloadVersions() {
        if (this.versionsLoading) {
            console.error('Cannot reload versions - another loading is running');
            return;
        }

        const org = this.org;
        if (org === null) {
            console.error('Cannot reload versions - organization is NULL');
            return;
        }

        this.versions = [];
        this.versionsLoading = true;
        this.selectedVersion = null;
        Ax<Array<Version>>(
            {
                url: `/api/budget/staffing_table/version-import/list?org-code=${encodeURIComponent(org.org.code)}`,
            },
            (data) => {
                this.versions = data;
            },
            (error) => {
                this.toast(
                    'danger',
                    this.i18n.translate('error.cannot_load_versions'),
                    error.toString(),
                )
            },
            () => {
                this.versionsLoading = false;
            },
        );
    }

    private dataSourceLabel(version: Version): string {
        return (version.favoriteImport ?? null) !== null
            ? translates.favoriteImportStatus.dataSource.favorit
            : translates.favoriteImportStatus.dataSource.eAkimat;
    }

    private dataSourceColor(version: Version): string {
        return (version.favoriteImport ?? null) !== null
            ? dataSourceColors.favorit
            : dataSourceColors.eAkimat;
    }

    private statusLabel(version: Version): string {
        const favoriteImport = version.favoriteImport ?? null;
        if (favoriteImport === null) return '';

        switch (favoriteImport.status) {
            case FavoriteImportStatusEnum.CREATED: return translates.favoriteImportStatus.status.created;
            case FavoriteImportStatusEnum.IMPORTING_EMPLOYEES: return translates.favoriteImportStatus.status.importing;
            case FavoriteImportStatusEnum.SUCCESS: return translates.favoriteImportStatus.status.success;
            case FavoriteImportStatusEnum.PARTIAL_SUCCESS: return translates.favoriteImportStatus.status.partialSuccess;
            case FavoriteImportStatusEnum.FAILED: return translates.favoriteImportStatus.status.failed;
            default: return '';
        }
    }

    /**
     * Иконка скачивания журнала ошибок: только для PARTIAL_SUCCESS/FAILED и только если пользователю есть что показать -
     * консультант/техподдержка видят все ошибки, остальные - только EMPLOYEE_NOT_LOADED и DISPLAYABLE_ERROR_TO_USER.
     */
    private canDownloadErrorReport(version: Version): boolean {
        const favoriteImport = version.favoriteImport ?? null;
        if (favoriteImport === null) return false;

        const hasErrorStatus = [FavoriteImportStatusEnum.PARTIAL_SUCCESS, FavoriteImportStatusEnum.FAILED].includes(favoriteImport.status);
        const canSeeErrors = staffTabAccess.isConsultant || staffTabAccess.isTechSupport || favoriteImport.userErrors;
        return hasErrorStatus && canSeeErrors;
    }

    private statusColor(version: Version): string {
        const favoriteImport = version.favoriteImport ?? null;
        if (favoriteImport === null) return '';

        switch (favoriteImport.status) {
            case FavoriteImportStatusEnum.CREATED: return statusColors.created;
            case FavoriteImportStatusEnum.IMPORTING_EMPLOYEES: return statusColors.importing;
            case FavoriteImportStatusEnum.SUCCESS: return statusColors.success;
            case FavoriteImportStatusEnum.PARTIAL_SUCCESS: return statusColors.partialSuccess;
            case FavoriteImportStatusEnum.FAILED: return statusColors.failed;
            default: return '';
        }
    }

    private get selectedVersionActionsBlocked(): boolean {
        const favoriteImport = this.selectedVersion?.favoriteImport ?? null;
        if (favoriteImport === null) {
            return false;
        }

        return (favoriteImport.status === FavoriteImportStatusEnum.CREATED)
            || (favoriteImport.status === FavoriteImportStatusEnum.IMPORTING_EMPLOYEES)
            || (favoriteImport.status === FavoriteImportStatusEnum.FAILED);
    }

    // Идентификаторы версий, для которых сейчас выполняется запрос обновления статуса импорта
    private refreshingVersionIds: number[] = [];

    private isRefreshing(version: Version): boolean {
        return this.refreshingVersionIds.includes(version.id);
    }

    private refreshVersionStatus(version: Version) {
        if (this.refreshingVersionIds.includes(version.id)) {
            return;
        }

        this.refreshingVersionIds.push(version.id);
        Ax<FavoriteImportStatus | null>(
            {
                url: `/api/budget/staffing_table/version-import/status?version-id=${version.id}`,
            },
            (data) => {
                version.favoriteImport = data;
            },
            (error) => {
                this.toast(
                    'danger',
                    translates.favoriteImportStatus.status.errors.refresh,
                    error.toString(),
                )
            },
            () => {
                const index = this.refreshingVersionIds.indexOf(version.id);
                if (index !== -1) {
                    this.refreshingVersionIds.splice(index, 1);
                }
            },
        );
    }

    private createVersion(oldVersion?: Version) {
        this.oldVersion = oldVersion ?? null;
        this.paramsModalYear = oldVersion?.year ?? new Date().getFullYear();
        this.paramsModalTitle = oldVersion?.title ?? '';
        this.paramsModalOrg = null;
        this.paramsModalOrgVisible = false;
        this.paramsModalVisible = true;

        this.paramsModalTextTitle = i18n.translate('choose_version_params');
        if ((oldVersion ?? null) === null) {
            this.paramsModalOkTitle = translates.create;
        } else {
            this.paramsModalOkTitle = translates.copyData;
        }
    }

    private continueVersionCreation() {
        if (this.versionsLoading) {
            console.error('Cannot create version - another loading is running');
            return;
        }

        // Организация
        /*
        this.paramsModalOrg - организация, выбранная пользователем в модальном окне "копирование версии"; может быть пропущена (null).
        this.org - организация, выбранная пользователем на странице; должна быть заполнена в момент выполнения текущего метода.

        Если пользователь выбрал организацию в модальном окне, значит он хочет скопировать версию в другую организацию,
        this.paramsModalOrg != null, используется this.paramsModalOrg.
        Если пользователь не выбрал организацию в модальном окне, значит он хочет скопировать версию в текущую организацию,
        this.paramsModalOrg == null, this.org != null, используется this.org.

        В любом случае org должна быть не равна null; если org равна null - что-то пошло совсем не так.
         */
        const org = this.paramsModalOrg ?? this.org;
        if (org === null) {
            console.error('Cannot create version - organization is NULL');
            return;
        }

        const year = this.paramsModalYear;
        const title = this.paramsModalTitle.trim();
        const oldVersion = this.oldVersion;

        let url = `/api/budget/staffing_table/version?org-code=${encodeURIComponent(org.org.code)}&year=${year}`;
        if (title.length > 0) {
            url += `&title=${encodeURIComponent(title)}`;
        }
        if (oldVersion !== null) {
            url += `&old-id=${oldVersion.id}`;
        }

        this.versionsLoading = true;
        Ax<Version>(
            {
                url: url,
                method: 'POST',
            },
            (data) => {
                const id = data.id;
                const year = data.year;
                this.toast(
                    'success',
                    '',
                    this.i18n.translate('success.created', [id, year]),
                );
                this.paramsModalVisible = false;
            },
            (error) => {
                this.toast(
                    'danger',
                    this.i18n.translate('error.cannot_create_new_version'),
                    error.toString(),
                )
            },
            () => {
                this.versionsLoading = false;
                this.resetVersions();
            },
        );
    }

  private get selectedGu(): Dict.Gu | null {
    if (this.org === null) return null;
    return this.org.gu;
  }

    private onVersionClick(version: Version) {
        if (this.selectedVersion === version) {
            this.selectedVersion = null;
        } else {
            this.selectedVersion = version;
        }
    }

    private onCreateNewClick() {
        this.createVersion();
    }

    private onCopyClick() {
        const selectedVersion = this.selectedVersion;
        if (selectedVersion === null) {
            console.error('Cannot copy version - selected version is NULL');
            return;
        }

        this.createVersion(selectedVersion);
    }

    private onCopyToAnotherOrgClick() {
        const selectedVersion = this.selectedVersion;
        if (selectedVersion === null) {
            console.error('Cannot copy version - selected version is NULL');
            return;
        }

        this.createVersion(selectedVersion);

        this.paramsModalTextTitle = this.translates.dataTransfer.modalTitle;
        this.paramsModalOrgVisible = true;
    }

    private onDeleteClick() {
        if (this.versionsLoading) {
            console.error('Cannot delete version - another loading is running');
            return;
        }

        const selectedVersion = this.selectedVersion;
        if (selectedVersion === null) {
            console.error('Cannot delete version - selected version is NULL');
            return;
        }
        const id = selectedVersion.id;

        this.showConfirmModal = false
        this.versionsLoading = true;
        Ax(
            {
                url: `/api/budget/staffing_table/version?id=${id}`,
                method: 'DELETE',
            },
            () => {
                this.toast(
                    'success',
                    '',
                    this.i18n.translate('success.deleted', [id]),
                )
            },
            (error) => {
                this.toast(
                    'danger',
                    this.i18n.translate('error.cannot_delete_version', [id]),
                    error.toString(),
                );
            },
            () => {
                this.versionsLoading = false;
                this.resetVersions();
            },
        );
    }

    private setVersionName(version: Version) {
        const newName = version.newTitle ?? null
        const idVersion = version.id

        if (newName == null) {
            console.error('Cannot set version title  - newTitle is null');
            return;
        }
        Ax(
            {
                url: '/api/budget/staffing_table/version/newTitle',
                method: 'PUT',
                params: {
                    newTitle: newName,
                    idVersion: idVersion
                }
            },
            () => {
                version.title = newName
                this.toast(
                    'success',
                    '',
                    this.i18n.translate('success.saved', [newName]),
                )
            },
            (error) => {
                this.toast(
                    'danger',
                    this.i18n.translate('error.cannot_save_newTitle_version'),
                    error.toString(),
                )
            },
            () => {
                version.newTitle = ''
            },
        );
    }

    // Идентификаторы версий, для которых сейчас выполняется скачивание отчёта об ошибках импорта
    private downloadingErrorReportVersionIds: number[] = [];

    private isDownloadingErrorReport(version: Version): boolean {
        return this.downloadingErrorReportVersionIds.includes(version.id);
    }

    private extractFileName(contentDisposition?: string | null): string | null {
        if (!contentDisposition) {
            return null;
        }

        const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;\n]+)/i);
        if (utf8Match) {
            try {
                return decodeURIComponent(utf8Match[1].trim());
            } catch {
                return utf8Match[1].trim();
            }
        }

        const asciiMatch = contentDisposition.match(/filename="?([^";\n]+)"?/i);
        return asciiMatch ? asciiMatch[1].trim() : null;
    }

    private downloadImportErrors(version: Version) {
        if (this.downloadingErrorReportVersionIds.includes(version.id)) {
            return;
        }

        this.downloadingErrorReportVersionIds.push(version.id);
        Ax<Blob>(
            {
                url: `/api/budget/staffing_table/integration/favorite/import/download-errors?version-id=${version.id}`,
        responseType: 'blob',
    },
        (data, response) => {
            const fileName = this.extractFileName(response.headers['content-disposition']) ?? 'Журнал ошибок.xlsx';
            const fileUrl = window.URL.createObjectURL(data);
            const link = document.createElement('a');

            link.href = fileUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(fileUrl);
        },
            (error) => {
                this.toast(
                    'danger',
                    translates.favoriteImportStatus.status.errors.errorsImportLoadingError,
                    error.toString(),
                );
            },
            () => {
                const index = this.downloadingErrorReportVersionIds.indexOf(version.id);
                if (index !== -1) {
                    this.downloadingErrorReportVersionIds.splice(index, 1);
                }
            },
    );
    }
    // endregion
}
